/**
 * Engine state slice
 */
export const engineSlice = {
    activeBuild: null,
    identity: null,
    loadState: 'idle', // 'idle' | 'loading' | 'ready' | 'error'
    latestScorePawns: null,
    latestScoreText: null, // as shown to the user: "+0.35", "M3"
    evalGeneration: 0,
    isEvaluating: false,
    latestDepth: null,
    isEnabled: false,
    error: null,
    showLines: false,
    evalHidden: false,
    pvLines: {},
};
